interface Props {
  variant?: 'apps' | 'admin';
  className?: string;
}

const VARIANT_CLASS: Record<NonNullable<Props['variant']>, string> = {
  apps: 'border-[3px] border-apps-corePrimary01 border-t-apps-corePrimary04',
  admin:
    'border-[3px] border-admin-primary-5767DD border-t-admin-sub-D5D9F7',
};

export default function Spinner({ variant = 'admin', className }: Props) {
  return (
    <div className={`flex items-center justify-center ${className ?? ''}`}>
      <div
        className={`inline-block h-[35px] w-[35px] animate-spinner rounded-full ${VARIANT_CLASS[variant]}`}
      />
    </div>
  );
}
